import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button } from 'shared/ui/Button';
import { StatusModal } from 'widgets/auth/_common/ui/StatusModal';

export const CPSuccessModal: FunctionComponent = () => {
	const navigate = useNavigate();
	const { t } = useTranslation();

	return (
		<StatusModal
			type={'success'}
			title={t('auth.status_modal.password_restored')}
			message={t('auth.status_modal.password_restored_message')}
		>
			<Button onClick={() => navigate('/sign-in')} type={'submit'} fullWidth>
				{t('auth.sign_in')}
			</Button>
		</StatusModal>
	);
};
